@if(isEditMode && form){
    <form [formGroup]="form" (ngSubmit)="confirmOrderInfo()">
        <section class="flex gap-large info-header">
            @if(isEditMode && orderInfo){
                <mat-form-field appearance="outline">
                    <mat-label>Order Id</mat-label>
                    <input readonly [value]="orderInfo.orderId" matInput>
                </mat-form-field>
            }
            <span class="flex">
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <input readonly formControlName="statusName" matInput>
                </mat-form-field>
                @if(orderInfo){
                    <button type="button" (click)="openChangeStatusModal()"><mat-icon>change_circle</mat-icon>Change</button>
                } @else {
                    <button type="button" disabled><mat-icon>change_circle</mat-icon>Change</button>
                }
            </span>
            <mat-form-field appearance="outline">
                <mat-label>Completion Date</mat-label>
                <input readonly formControlName="completionDate" matInput>
            </mat-form-field>
        </section>
        <section class="flex gap-large">
            <div class="flex column gap">
                <span class="flex">
                    <mat-form-field appearance="outline">
                        <mat-label>Photographer</mat-label>
                        <input readonly formControlName="photographerName" matInput>
                    </mat-form-field>
                    <button type="button" (click)="openChangePhotographerModal()"><mat-icon>edit</mat-icon></button>
                </span>
                <span class="flex">
                    <mat-form-field appearance="outline">
                        <mat-label>Creation Date</mat-label>
                        <input readonly [matDatepicker]="creationDatePicker" formControlName="creationDate" matInput>
                        <mat-datepicker #creationDatePicker></mat-datepicker>
                    </mat-form-field>
                    <button type="button"><mat-icon>calendar_month</mat-icon></button>
                </span>
                <span class="flex">
                    <mat-form-field appearance="outline">
                        <mat-label>Due Date</mat-label>
                        <input [matDatepicker]="dueDatePicker" formControlName="dueDate" matInput>
                        <mat-datepicker #dueDatePicker></mat-datepicker>
                    </mat-form-field>
                    <button type="button" (click)="dueDatePicker.open()"><mat-icon>calendar_month</mat-icon></button>
                </span>
                <button type="submit" [disabled]="form.invalid">
                    <mat-icon>save</mat-icon>
                {{ isNewOrder ? 'Confirm Order Info' : 'Save Order Info' }}
                </button>
            </div>
            <div>
                <mat-form-field appearance="outline" style="height: 100%;">
                    <mat-label>Note</mat-label>
                    <textarea formControlName="notes" matInput style="resize: none; overflow: auto;"></textarea>
                </mat-form-field>
            </div>
        </section>
    </form>
} @else if(orderInfo && form) {
    <section class="flex gap-large info-header">
        <mat-form-field appearance="outline">
            <mat-label>Order Id</mat-label>
            <input readonly [value]="orderInfo.orderId" matInput>
        </mat-form-field>
        <span class="flex">
            <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <input readonly [value]="orderInfo.statusName" matInput>
            </mat-form-field>
            <button type="button" (click)="openChangeStatusModal()"><mat-icon>change_circle</mat-icon>Change</button>
        </span>
        <mat-form-field appearance="outline">
            <mat-label>Completion Date</mat-label>
            <input readonly [value]="orderInfo.completitionDate ? orderInfo.completitionDate : '-'" matInput>
        </mat-form-field>
    </section>
    <section class="flex gap-large">
        <div class="flex column gap">
            <span class="flex">
                <mat-form-field appearance="outline">
                    <mat-label>Photographer</mat-label>
                    <input readonly [value]="orderInfo.photographerName" matInput>
                </mat-form-field>
                <button type="button" (click)="openChangePhotographerModal()"><mat-icon>edit</mat-icon></button>
            </span>
            <span class="flex">
                <mat-form-field appearance="outline">
                    <mat-label>Creation Date</mat-label>
                    <input readonly [value]="orderInfo.creationDate | date: 'dd/MM/yyyy'" matInput>
                </mat-form-field>
                <button type="button"><mat-icon>calendar_month</mat-icon></button>
            </span>
            @if(editNotesAndDueDate){
                <span class="flex">
                    <mat-form-field appearance="outline">
                        <mat-label>Due Date</mat-label>
                        <input [matDatepicker]="dueDatePickerView" formControlName="dueDate" matInput>
                        <mat-datepicker #dueDatePickerView></mat-datepicker>
                    </mat-form-field>
                    <button type="button" (click)="dueDatePickerView.open()"><mat-icon>calendar_month</mat-icon></button>
                </span>
                <button type="button" (click)="saveNotesAndDueDate()"><mat-icon>save</mat-icon>Save notes &amp; due date</button>
            } @else {
                <span class="flex">
                    <mat-form-field appearance="outline">
                        <mat-label>Due Date</mat-label>
                        <input readonly [value]="orderInfo.dueDate | date: 'dd/MM/yyyy'" matInput>
                    </mat-form-field>
                    <button type="button" (click)="toggleEditNotesAndDueDate()"><mat-icon>edit</mat-icon>Edit</button>
                </span>
            }
        </div>
        <div>
            @if(editNotesAndDueDate){
                <mat-form-field appearance="outline" style="height: 100%;">
                    <mat-label>Note</mat-label>
                    <textarea formControlName="notes" matInput style="resize: none; overflow: auto;"></textarea>
                </mat-form-field>
            } @else {
                <mat-form-field appearance="outline" style="height: 100%;">
                    <mat-label>Note</mat-label>
                    <textarea readonly [value]="orderInfo.notes" matInput style="resize: none; overflow: auto;"></textarea>
                </mat-form-field>
                <button type="button" (click)="toggleEditNotesAndDueDate()"><mat-icon>edit</mat-icon>Edit notes</button>
            }
        </div>
    </section>
}
